import type { Stroke } from '@etown/shared';
import { BOARD_HEIGHT, BOARD_WIDTH, clearBoard, drawStroke } from './whiteboardCanvas';

interface Board {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
}

/**
 * Zeichenflaechen der Whiteboards ausserhalb des Modals: damit man in der
 * Ego-Ansicht schon von weitem sieht, was auf einem Board steht, wird der
 * Inhalt mitgeschrieben, auch wenn niemand das Modal geoeffnet hat.
 *
 * Der Server sendet Striche ohnehin an den ganzen Raum — hier landen sie
 * einfach zusaetzlich auf einer eigenen Flaeche.
 */
class BoardTextures {
  private readonly boards = new Map<string, Board>();

  /** Flaeche eines Boards; wird beim ersten Zugriff leer angelegt. */
  canvasFor(objectId: string): HTMLCanvasElement {
    return this.board(objectId).canvas;
  }

  has(objectId: string): boolean {
    return this.boards.has(objectId);
  }

  apply(objectId: string, stroke: Stroke): void {
    drawStroke(this.board(objectId).ctx, stroke);
  }

  clear(objectId: string): void {
    clearBoard(this.board(objectId).ctx);
  }

  /** Alles vergessen — beim Verlassen des Raums. */
  reset(): void {
    this.boards.clear();
  }

  private board(objectId: string): Board {
    const existing = this.boards.get(objectId);
    if (existing) return existing;
    const canvas = document.createElement('canvas');
    canvas.width = BOARD_WIDTH;
    canvas.height = BOARD_HEIGHT;
    const ctx = canvas.getContext('2d')!;
    clearBoard(ctx);
    const board = { canvas, ctx };
    this.boards.set(objectId, board);
    return board;
  }
}

export const boardTextures = new BoardTextures();
